<template>
  <div class="ui center aligned basic segment" id="screen" style="overflow:auto;display:flex;margin:0">
    <div class="ui center aligned container purple segment" style="display:inline-block;margin:auto">
      <h3 class="header">Offline Jobs</h3>
      <h4 class="ui header">Live [{{  lol.length }}]:</h4>
      <div class="ui divided items" style="text-align:left">
        <div class="item" v-for="(ol,index) in lol" :key="index">
          <div class="content">
            <div class="ui header">{{ new Date(ol.id).toLocaleString() }}</div>
            <div class="meta">url: {{ ol.url }}</div>
          </div>
        </div>
      </div>
      <h4 class="ui header">Errored [{{  eol.length }}]:</h4>
      <div class="ui divided items" style="text-align:left">
        <div class="item" v-for="(el,index) in eol" :key="index">
          <div class="content">
            <div class="ui header">{{ new Date(el.id).toLocaleString() }}</div>
            <div class="meta">url: {{ el.url }}</div>
            <div class="meta">Error: {{ el.err }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        lol:[],
        eol:[]
      };
    },
    methods: {
      getOfflineJobs() {
        var thiz = this;
        this.$offlineUploader.getErrors((errors)=>{
          thiz.eol = errors;
        });

        this.$offlineUploader.getJobs((jobs)=>{
          thiz.lol = jobs;
        });
      }
    },
    mounted() {
      setTimeout(()=>{
        const e = document.querySelector('#purpleheader').animate({height:"130px"}, 500)
        e.onfinish = ()=>{
          document.querySelector('#purpleheader').style.height = "130px";
        };
      },0);
      this.getOfflineJobs();
    }
  }
</script>
